import { PostHogProvider } from 'posthog-js/react';
import { FC, PropsWithChildren } from 'react';
import { isProduction, postHogApiKey, postHogOptions } from 'src/config';

export const PostHogProviderWrapper: FC<PropsWithChildren> = ({ children }) => {
  if (!isProduction) return <>{children}</>;
  return (
    <PostHogProvider apiKey={postHogApiKey} options={postHogOptions}>
      {children}
    </PostHogProvider>
  );
};
